import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { CloseButton, ExportButton } from "../Buttons";

const ExportExcelModal = ({ show, onCloseClick, title, isExporting }) => {

  const handleClick = (e) => {
    onCloseClick(e)
  };

  return (
    <Modal isOpen={show} toggle={() => onCloseClick(false)} centered={true}>
      <ModalHeader toggle={() => onCloseClick(false)} className="p-3 bg-info-subtle">
        {title}
      </ModalHeader>
      <ModalBody className="py-3 px-5">
        <div className="text-center">

          <lord-icon
            src="https://cdn.lordicon.com/wzwygmng.json"
            trigger="loop"
            stroke="bold"
            state="loop-roll"
            colors="primary:#0ab39c,secondary:#0ab39c"
            style={{ width: "60px", height: "60px" }}
          >
          </lord-icon>

          <div className="pt-2 fs-15 mx-sm-5">
            <h4>Are you sure?</h4>
            <p className="text-muted mb-0">
              Are you sure you want to export the current list to an Excel file?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <CloseButton onClick={() => handleClick(false)} />
          <ExportButton isExporting={isExporting} onClick={() => handleClick(true)} />
        </div>
      </ModalBody>
    </Modal>
  );
};

ExportExcelModal.propTypes = {
  onCloseClick: PropTypes.func,
  data: PropTypes.any,
  show: PropTypes.any,
  title: PropTypes.string,
};

export default ExportExcelModal;
